var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwiftuniMessangerQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 101 721v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,132,752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101 783v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,132,814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101 907v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,132,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101 1093v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,132,1124)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,132,1186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 1217,
    width: 62,
    height: 62,
    transform: "rotate(0,132,1248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101 1279v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,132,1310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 597v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,194,628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 845v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,194,876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 907v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,194,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 1031v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,194,1062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 1155v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,194,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 1341v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,194,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 969v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,256,1000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 1031v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,256,1062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225 1217v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,256,1248)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,256,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 287 597v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,318,628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 287 659v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,318,690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 287 1093v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,318,1124)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,318,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 287 1279v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,318,1310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 287 1341v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,318,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 349 597v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,380,628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 349 721v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,380,752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 349 907v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,380,938)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 969,
    width: 62,
    height: 62,
    transform: "rotate(0,380,1000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 349 1031v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,380,1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,380,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 349 1279v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,380,1310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 411 659v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,442,690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 411 845v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,442,876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 411 907v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,442,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 411 1093v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,442,1124)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,442,1186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 1217,
    width: 62,
    height: 62,
    transform: "rotate(0,442,1248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 473 597v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,504,628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 473 721v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,504,752)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 845,
    width: 62,
    height: 62,
    transform: "rotate(0,504,876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 473 969v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,504,1000)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 1093,
    width: 62,
    height: 62,
    transform: "rotate(0,504,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 473 1217v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,504,1248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 473 1341v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,504,1372)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 597,
    width: 62,
    height: 62,
    transform: "rotate(0,566,628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 845,
    width: 62,
    height: 62,
    transform: "rotate(0,566,876)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 969,
    width: 62,
    height: 62,
    transform: "rotate(0,566,1000)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 1031,
    width: 62,
    height: 62,
    transform: "rotate(0,566,1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 1093,
    width: 62,
    height: 62,
    transform: "rotate(0,566,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 535 1341v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,566,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 163v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,628,194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 287v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,628,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,628,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 411,
    width: 62,
    height: 62,
    transform: "rotate(0,628,442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 473v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,628,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 597,
    width: 62,
    height: 62,
    transform: "rotate(0,628,628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 659,
    width: 62,
    height: 62,
    transform: "rotate(0,628,690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 783v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,628,814)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 845,
    width: 62,
    height: 62,
    transform: "rotate(0,628,876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 969v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,628,1000)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597,
    y: 1093,
    width: 62,
    height: 62,
    transform: "rotate(0,628,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 1217v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,628,1248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 1279v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,628,1310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 1403v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,628,1434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 1465v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,628,1496)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 1589v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,628,1620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 1651v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,628,1682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 597 1775v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,628,1806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659,
    y: 163,
    width: 62,
    height: 62,
    transform: "rotate(0,690,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,690,256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659 411v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,690,442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659 535v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,690,566)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659,
    y: 597,
    width: 62,
    height: 62,
    transform: "rotate(0,690,628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659 659v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,690,690)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659,
    y: 845,
    width: 62,
    height: 62,
    transform: "rotate(0,690,876)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659,
    y: 907,
    width: 62,
    height: 62,
    transform: "rotate(0,690,938)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659,
    y: 1093,
    width: 62,
    height: 62,
    transform: "rotate(0,690,1124)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,690,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659 1341v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,690,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659 1527v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,690,1558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659 1589v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,690,1620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659 1713v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,690,1744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 659 1775v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,690,1806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,752,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,752,318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 349v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,752,380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 473v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,752,504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 535v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,752,566)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 721v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,752,752)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 783,
    width: 62,
    height: 62,
    transform: "rotate(0,752,814)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 845,
    width: 62,
    height: 62,
    transform: "rotate(0,752,876)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 907,
    width: 62,
    height: 62,
    transform: "rotate(0,752,938)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,752,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 1217v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,752,1248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 1403v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,752,1434)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,752,1496)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 1527v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,752,1558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 783 163v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,814,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,814,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,814,318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 783 597v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,814,628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783,
    y: 721,
    width: 62,
    height: 62,
    transform: "rotate(0,814,752)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783,
    y: 845,
    width: 62,
    height: 62,
    transform: "rotate(0,814,876)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783,
    y: 907,
    width: 62,
    height: 62,
    transform: "rotate(0,814,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 783 1093v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,814,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 783 1155v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,814,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 783 1279v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,814,1310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 783 1341v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,814,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 783 1589v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,814,1620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 783 1651v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,814,1682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 783 1837v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,814,1868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 163v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,876,194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 287v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,876,318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 411v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,876,442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 473v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,876,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845,
    y: 597,
    width: 62,
    height: 62,
    transform: "rotate(0,876,628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845,
    y: 659,
    width: 62,
    height: 62,
    transform: "rotate(0,876,690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 721v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,876,752)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845,
    y: 907,
    width: 62,
    height: 62,
    transform: "rotate(0,876,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 1031v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,876,1062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 1217v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,876,1248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 1279v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,876,1310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 1403v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,876,1434)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,876,1496)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 845 1775v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,876,1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 225v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,938,256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 411v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,938,442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 535v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,938,566)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907,
    y: 597,
    width: 62,
    height: 62,
    transform: "rotate(0,938,628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 659v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,938,690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 783v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,938,814)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907,
    y: 907,
    width: 62,
    height: 62,
    transform: "rotate(0,938,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 1031v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,938,1062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 1155v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,938,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 1217v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,938,1248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 1465v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,938,1496)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 1589v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,938,1620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 1713v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,938,1744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907 1837v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,938,1868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 101v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1000,132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 163v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1000,194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 287v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1000,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,1000,380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 473v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1000,504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 845v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1000,876)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969,
    y: 907,
    width: 62,
    height: 62,
    transform: "rotate(0,1000,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 969v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1000,1000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 1093v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1000,1124)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,1000,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 1279v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1000,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1000,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 1527v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1000,1558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 969 1651v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1000,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969,
    y: 1837,
    width: 62,
    height: 62,
    transform: "rotate(0,1000,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1031 225v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1062,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1031 411v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1062,442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1031 535v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1062,566)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 597,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 659,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,690)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 721,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,752)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 907,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1031 1031v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1062,1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1031 1217v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1062,1248)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1031 1403v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1062,1434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1031 1589v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1062,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,1744)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031,
    y: 1775,
    width: 62,
    height: 62,
    transform: "rotate(0,1062,1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1031 1837v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1062,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1124,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,1124,256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1093 473v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1124,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 721,
    width: 62,
    height: 62,
    transform: "rotate(0,1124,752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1093 845v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1124,876)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 907,
    width: 62,
    height: 62,
    transform: "rotate(0,1124,938)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 1031,
    width: 62,
    height: 62,
    transform: "rotate(0,1124,1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 1093,
    width: 62,
    height: 62,
    transform: "rotate(0,1124,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1093 1155v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1124,1186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1093 1527v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1124,1558)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,1124,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,1124,1682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1093 1775v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1124,1806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1186,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155,
    y: 163,
    width: 62,
    height: 62,
    transform: "rotate(0,1186,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,1186,256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1155 349v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1186,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155,
    y: 721,
    width: 62,
    height: 62,
    transform: "rotate(0,1186,752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1155 783v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1186,814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1155 907v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1186,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1155 1093v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1186,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1155 1217v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1186,1248)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155,
    y: 1279,
    width: 62,
    height: 62,
    transform: "rotate(0,1186,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1186,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1155 1465v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1186,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,1186,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,1186,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 163,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1217 225v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1248,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 411,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 535,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,566)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 597,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 659,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1217 845v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1248,876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1217 1031v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1248,1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 1279,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1217 1527v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1248,1558)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,1248,1744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1217 1837v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1248,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 163,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1279 411v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1310,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 659,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,690)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 845,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1279 1217v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1310,1248)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1279,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,1372)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1403,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,1434)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,1496)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1279 1589v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1310,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,1310,1744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1279 1837v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1310,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 163,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1341 287v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1372,318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1341 473v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1372,504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1341 535v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1372,566)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 659,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,690)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 721,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,752)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 845,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,876)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 907,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,938)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 969,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1000)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 1031,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 1093,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1341 1155v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1372,1186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1372)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 1403,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1434)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 1527,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1558)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1744)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 1775,
    width: 62,
    height: 62,
    transform: "rotate(0,1372,1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1403 597v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1434,628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403,
    y: 721,
    width: 62,
    height: 62,
    transform: "rotate(0,1434,752)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403,
    y: 783,
    width: 62,
    height: 62,
    transform: "rotate(0,1434,814)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403,
    y: 1031,
    width: 62,
    height: 62,
    transform: "rotate(0,1434,1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403,
    y: 1093,
    width: 62,
    height: 62,
    transform: "rotate(0,1434,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1403 1217v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1434,1248)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403,
    y: 1279,
    width: 62,
    height: 62,
    transform: "rotate(0,1434,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1434,1372)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,1434,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,1434,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,1434,1744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1403 1775v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1434,1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1465 659v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1496,690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1465 783v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1496,814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1465 907v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1496,938)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 1031,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 1093,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,1124)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,1186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 1217,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,1248)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 1279,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1465 1465v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1496,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,1620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1465 1713v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1496,1744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1527 597v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1558,628)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1527,
    y: 659,
    width: 62,
    height: 62,
    transform: "rotate(0,1558,690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1527 845v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1558,876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1527 969v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1558,1000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1527 1031v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1558,1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1527,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,1558,1186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1527,
    y: 1279,
    width: 62,
    height: 62,
    transform: "rotate(0,1558,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1527,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1558,1372)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1527,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,1558,1620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1527 1651v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1558,1682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1527 1775v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1558,1806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 597,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1589 659v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1620,690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1589 907v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1620,938)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 969,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,1000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1589 1093v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1620,1124)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 1155,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,1186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 1217,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,1248)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 1279,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,1372)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 1403,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,1434)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 1527,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,1558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1589 1589v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1620,1620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1651 597v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1682,628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1651 721v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1682,752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1651 845v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1682,876)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 969,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,1000)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 1093,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1651 1155v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1682,1186)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 1527,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,1558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1651 1651v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1682,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,1744)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 1775,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1713 783v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1744,814)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1713 969v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1744,1000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1713 1093v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1744,1124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1713 1217v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1744,1248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1713 1341v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1744,1372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1713 1403v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1744,1434)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713,
    y: 1527,
    width: 62,
    height: 62,
    transform: "rotate(0,1744,1558)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,1744,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,1744,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713,
    y: 1775,
    width: 62,
    height: 62,
    transform: "rotate(0,1744,1806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713,
    y: 1837,
    width: 62,
    height: 62,
    transform: "rotate(0,1744,1868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1775 597v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1806,628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1775 1031v 31a 31 31, 0, 0, 0, 31 31h 31v -31a 31 31, 0, 0, 0, -31 -31",
    transform: "rotate(90,1806,1062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1775 1279v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1806,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1806,1372)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,1806,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,1806,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,1806,1744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1775 1837v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1806,1868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1837 907v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1868,938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1837 969v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1868,1000)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 1279,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,1310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 1341,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,1372)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 1403,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,1434)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 1527,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,1558)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,1682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1837 1713v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1868,1744)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 101 101v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,132,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 163,
    width: 62,
    height: 62,
    transform: "rotate(0,132,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,132,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,132,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,132,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 411,
    width: 62,
    height: 62,
    transform: "rotate(0,132,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,132,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,194,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,194,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,256,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,256,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,318,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,318,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,380,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,380,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,442,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,442,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,504,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 163,
    width: 62,
    height: 62,
    transform: "rotate(0,504,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,504,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,504,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,504,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 411,
    width: 62,
    height: 62,
    transform: "rotate(0,504,442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 473 473v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,504,504)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225 225v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,256,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,256,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,256,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,318,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,318,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,318,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,380,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,380,318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 349 349v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,380,380)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1465 101v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1496,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 163,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 411,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,1496,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1527,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1558,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1527,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,1558,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1744,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,1744,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1806,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775,
    y: 473,
    width: 62,
    height: 62,
    transform: "rotate(0,1806,504)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 101,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,132)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 163,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1837,
    y: 411,
    width: 62,
    height: 62,
    transform: "rotate(0,1868,442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1837 473v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1868,504)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1589 225v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,1620,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,1620,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,318)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1651,
    y: 349,
    width: 62,
    height: 62,
    transform: "rotate(0,1682,380)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713,
    y: 225,
    width: 62,
    height: 62,
    transform: "rotate(0,1744,256)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1713,
    y: 287,
    width: 62,
    height: 62,
    transform: "rotate(0,1744,318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1713 349v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,1744,380)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 101 1465v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,132,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 1527,
    width: 62,
    height: 62,
    transform: "rotate(0,132,1558)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,132,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,132,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,132,1744)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 1775,
    width: 62,
    height: 62,
    transform: "rotate(0,132,1806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 1837,
    width: 62,
    height: 62,
    transform: "rotate(0,132,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,194,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 1837,
    width: 62,
    height: 62,
    transform: "rotate(0,194,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,256,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 1837,
    width: 62,
    height: 62,
    transform: "rotate(0,256,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,318,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 1837,
    width: 62,
    height: 62,
    transform: "rotate(0,318,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,380,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 1837,
    width: 62,
    height: 62,
    transform: "rotate(0,380,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,442,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 1837,
    width: 62,
    height: 62,
    transform: "rotate(0,442,1868)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 1465,
    width: 62,
    height: 62,
    transform: "rotate(0,504,1496)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 1527,
    width: 62,
    height: 62,
    transform: "rotate(0,504,1558)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,504,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,504,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,504,1744)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 1775,
    width: 62,
    height: 62,
    transform: "rotate(0,504,1806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 473 1837v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,504,1868)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225 1589v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(-90,256,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,256,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,256,1744)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,318,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,318,1682)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 1713,
    width: 62,
    height: 62,
    transform: "rotate(0,318,1744)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 1589,
    width: 62,
    height: 62,
    transform: "rotate(0,380,1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 1651,
    width: 62,
    height: 62,
    transform: "rotate(0,380,1682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 349 1713v 62h 62a 62 62, 0, 0, 0, -62 -62",
    transform: "rotate(90,380,1744)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 2000,
    width: 2000,
    clipPath: "url('#clip-path-background-color')",
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 101,
    height: 1798,
    width: 1798,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 101,
    height: 434,
    width: 434,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 225,
    height: 186,
    width: 186,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1465,
    y: 101,
    height: 434,
    width: 434,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1589,
    y: 225,
    height: 186,
    width: 186,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 1465,
    height: 434,
    width: 434,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 1589,
    height: 186,
    width: 186,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftuniMessangerQr);
export default __webpack_public_path__ + "static/media/swiftuni-messanger-qr.316311e5082e1f3fed2b34d716138933.svg";
export { ForwardRef as ReactComponent };